<template>
  <div class="has-text-left">
      <Presentation
        v-if="getShowSondagePresentation"
        :sondage_presentation="sondage_presentation"
      />
    <form
      v-show="!getShowSondagePresentation && !steps.authorizedThanks"
      id="form"
      name="myForm"
      v-on:submit.prevent="onSubmit"
    >
      <div v-for="(question, index) in questions" :key="index">
        <div
          v-show="
            steps.nowStep === index + 1 &&
              $store.state.sondage.languagesAdmin.includes(
                choosenLanguageClient
              )
          "
          class="bloc"
        >
          <Step
            v-show="steps.nowStep === index + 1"
            v-if="!steps.authorizedThanks"
          />
          <Buttons
            v-if="question.optional === 0 || question.optional === 1"
            :sondage_type="sondage_type"
            :viewColidee="viewColidee"
            v-show="steps.nowStep === index + 1"
            :index="index"
            :window="window"
            :question="question"
          />
        </div>
        <div v-show="index + 1 === steps.nowStep">
          <div class="bloc">
            <Question
              style="padding:20px;"
              :question="question"
              :index="index"
              ref="questionComponent"
            />
          </div>
        </div>
      </div>
    </form>
    <transition name="fade">
      <Thanks
        v-if="steps.authorizedThanks"
        :colidee="colidee"
        :viewColidee="viewColidee"
        :sondage_type="sondage_type"
        :sondage_thanks="sondage_thanks"
      />
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import EventBus from '@/eventBus'
import { mapGetters } from 'vuex'
import Question from '@/components/formulaire/formulaire_layouts/Question'
import Thanks from '@/components/formulaire/Thanks'
import Presentation from '@/components/formulaire/Presentation'
import Buttons from '../buttons/buttons.vue'
import Step from '@/components/formulaire/Step'

export default {
  name: 'SondageFormSimple',
  data () {
    return {
      VotePossible: true,
      show_thanks: false,
      languageClient: ''
    }
  },
  components: {
    Question,
    Buttons,
    Step,
    Thanks,
    Presentation
  },
  props: {
    viewColidee: {
      required: false
    },
    colidee: {
      required: true
    },
    window: {
      required: true
    },
    urlparticipant: {
      type: String,
      required: true
    },
    sondage_id: {
      type: Number | String,
      required: true
    },
    sondage_type: {
      type: String,
      required: true
    },
    sondage_thanks: {
      type: String,
      required: false
    },
    sondage_presentation: {
      type: String,
      required: false
    }
  },
  updated () {
    this.$nextTick(function () {
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
    })
  },
  computed: {
    ...mapGetters(['steps', 'questions', 'choosenLanguageClient', 'getShowSondagePresentation'])
  },
  watch: {
    questions () {
      if (this.sondage_presentation) {
        this.$store.commit('UPDATE_SHOW_SONDAGE_PRESENTATION', true)
      }
      this.$store.commit('STEPS_LENGTH', {
        type: 'questions',
        data: this.$store.state.question.questions
      })
      this.udpateButtonSendForm()
    }
  },
  created () {
    EventBus.$on('resetForm_client', this.resetForm)
    if (this.$store.state.question.questions) this.updateStepsLengthQuestion()
    if (this.$store.state.question.questions) this.udpateButtonSendForm()
  },
  beforeDestroy () {
    EventBus.$off('resetForm_client')
  },
  methods: {
    udpateButtonSendForm () {
      if (
        this.$store.state.question.questions[0].optional &&
        this.$store.state.question.questions.length === 1
      ) {
        this.$store.commit('UPDATE_AUTHORIZED_FORM', true)
      }
    },
    updateStepsLengthQuestion () {
      this.$store.commit('STEPS_LENGTH', {
        type: 'questions',
        data: this.$store.state.question.sections
      })
    },
    resetForm () {
      /* replay on peut re-voter directement */
      if (this.sondage_type == 'replay') {
        this.$refs.questionComponent.forEach(function (el) {
          el.reloaded++
        })
        this.$store.commit('RESET_NOWSTEP')
        this.$store.dispatch('getQuestionsPublic', {
          urlparticipant: this.urlparticipant,
          idSondage: this.sondage_id
        })
        this.$store.commit('RESET_STORE_SECTION_FORM')
        this.updateStepsLengthQuestion()
        EventBus.$emit('update_showLocalButton')
      }
      /* relog on doit rentrer à nouveau le code participant -> reroutage vers HOME */
      if (this.sondage_type == 'relog') {
        this.$router.push({ name: 'home' })
      }
      /* Block on revient à la page d'accueil  HOME */
      if (this.sondage_type == 'block') {
        this.$router.push({ name: 'home' })
      }
    },
    onSubmit (el) {
      if (this.steps.nowStep === this.questions.length) {
        if (this.steps.authorizedVote === true) {
          this.$store.commit('UPDATE_AUTHORIZED_VOTE', false)
          this.$store.commit('UPDATE_AUTHORIZED_THANKS', true)
          this.$store.dispatch('vote_enregistre', this.sondage_id)
          var serialize = require('form-serialize')
          var form = el.target
          var reponsesJSON = serialize(form, { hash: true })
          axios.defaults.headers.common['urlparticipant'] = this.urlparticipant
          axios
            .post(
              process.env.URL_SSO_API +
                'sondage/public/sondage/' +
                this.sondage_id +
                '/result',
              reponsesJSON
            )
            .then(response => {
              EventBus.$emit('counter_thanks-component')
              el.target.reset()
            })
            .catch(error => {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: this.$i18n.t('toast.network_error')
              })
            })
        }
      }
    }
  }
}
</script>

<style scoped>
.formulaire {
  position: relative;
}

.bloc-steps {
  background: #ffffff;
  border: 1px #dddbdc solid;
}
</style>



// WEBPACK FOOTER //
// src/components/formulaire/formulaire_simple/SondageFormSimple.vue